/**
 * 匿名セッションの自動発行（アカウント概念のUIUX排除・2026-06-12 社長要望）。
 * セッションが無ければ Supabase 匿名ユーザーを裏で自動作成し、全画面を登録なしで体験可能にする。
 * 後日「ここから先は登録」のゲートを入れる際は、この匿名ユーザーに本登録を紐付ける（updateUser）。
 */
import { supabase, SUPABASE_URL, SUPABASE_ANON_KEY } from "./supabase";

const TRIED_KEY = "shitamy-anon-attempted";

export async function ensureAnonSession(): Promise<void> {
  const { data } = await supabase.auth.getSession();
  if (data.session) return;
  // 失敗時の無限リロード防止（タブ単位で1回だけ試行）
  if (sessionStorage.getItem(TRIED_KEY)) return;
  sessionStorage.setItem(TRIED_KEY, "1");
  try {
    const r = await fetch(`${SUPABASE_URL}/auth/v1/signup`, {
      method: "POST",
      headers: { apikey: SUPABASE_ANON_KEY, "Content-Type": "application/json" },
      body: "{}",
    });
    const j = await r.json();
    if (!r.ok || !j.access_token) return;
    const ref = new URL(SUPABASE_URL).hostname.split(".")[0];
    localStorage.setItem(`sb-${ref}-auth-token`, JSON.stringify(j));
    window.location.replace(window.location.origin);
  } catch {
    /* オフライン等は静かに諦める（次回タブで再試行） */
  }
}
